// extracted by mini-css-extract-plugin
export default {"inner":"Agreement_inner__WwxEW","text":"Agreement_text__Eu9AP"};